import api from "../../../core/api";
import {
  ProgressUpdate,
  MarkWorkCompleteRequest,
  ServiceCompletionDetails,
} from "../../servicing/models/executionModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

class OfferExecutionApi {
  startWork(offerId: string): Promise<any> {
    return api
      .post(
        `/v1/customer/offers/${offerId}/execution/start-work`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  addProgressUpdate(offerId: string, message: string): Promise<ProgressUpdate> {
    return api
      .post<ProgressUpdate>(
        `/v1/customer/offers/${offerId}/execution/progress`,
        { message },
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  getProgressUpdates(offerId: string): Promise<ProgressUpdate[]> {
    return api
      .get<ProgressUpdate[]>(
        `/v1/customer/offers/${offerId}/execution/progress`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  markWorkComplete(
    offerId: string,
    data: MarkWorkCompleteRequest
  ): Promise<ServiceCompletionDetails> {
    return api
      .post<ServiceCompletionDetails>(
        `/v1/customer/offers/${offerId}/execution/mark-complete`,
        data,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  getCompletion(offerId: string): Promise<ServiceCompletionDetails> {
    return api
      .get<ServiceCompletionDetails>(
        `/v1/customer/offers/${offerId}/execution/completion`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }
}

export default new OfferExecutionApi();
